import { createAction } from '@reduxjs/toolkit';

export const blogUpdateId = createAction('blog/updateId');
export const blogUpdateUID = createAction('blog/updateUid');
export const blogUpdateSID = createAction('blog/updateSid');
export const blogUpdateIsAdded = createAction('blog/updateIsAdded');
export const blogUpdateIsActive = createAction('blog/updateIsActive');

export const blogStore = createAction('blog/store');
export const blogClear = createAction('blog/clear');

export const blogUpdateRequesting = createAction('blog/updateRequesting');
export const blogUpdateRequest = createAction('blog/updateRequest');
export const blogUpdateError = createAction('blog/updateError');
export const blogUpdateStore = createAction('blog/updateStore');

export const blogUpdateItems = createAction('blog/updateItems');

export const blogUpdateLayout = createAction('blog/updateLayout');
export const blogUpdateView = createAction('blog/updateView');

export const blogUpdateHeadingTitle = createAction('blog/updateHeadingTitle');
export const blogUpdateHeadingDescription = createAction('blog/updateHeadingDescription');
export const blogUpdateHeadingTextAlign = createAction('blog/updateHeadingTextAlign');
export const blogUpdateHeadingImage = createAction('blog/updateHeadingImage');
export const blogUpdateHeadingDivider = createAction('blog/updateHeadingDivider');

export const blogUpdateSectionIsBackground = createAction('blog/updateSectionIsBackground');
export const blogUpdateSectionTextColor = createAction('blog/updateSectionTextColor');
export const blogUpdateSectionBackgroundColor = createAction('blog/updateSectionBackgroundColor');
export const blogUpdateSectionOpacity = createAction('blog/updateSectionOpacity');
export const blogUpdateSectionIsFullWidth = createAction('blog/updateSectionIsFullWidth');
export const blogUpdateSectionShadow = createAction('blog/updateSectionShadow');
export const blogUpdateSectionShadowColor = createAction('blog/updateSectionShadowColor');
export const blogUpdateSectionPadding = createAction('blog/updateSectionPadding');
export const blogUpdateSectionMargin = createAction('blog/updateSectionMargin');
export const blogUpdateSectionBackgroundType = createAction('blog/updateSectionBackgroundType');
export const blogUpdateSectionBackgroundImage = createAction('blog/updateSectionBackgroundImage');
export const blogUpdateSectionGradientColor1 = createAction('blog/updateSectionGradientColor1');
export const blogUpdateSectionGradientColor2 = createAction('blog/updateSectionGradientColor2');
export const blogUpdateSectionGradientDirection = createAction('blog/updateSectionGradientDirection');
export const blogUpdateSectionGradientOffset = createAction('blog/updateSectionGradientOffset');
export const blogUpdateSectionBorder = createAction('blog/updateSectionBorder');
export const blogUpdateSectionBorderColor = createAction('blog/updateSectionBorderColor');
export const blogUpdateSectionShadowBorderColor = createAction('blog/updateSectionShadowBorderColor');
export const blogUpdateSectionShape = createAction('blog/updateSectionShape');

export const blogUpdateItemOpacity = createAction('blog/updateItemOpacity');
export const blogUpdateItemShadow = createAction('blog/updateItemShadow');
export const blogUpdateItemShadowColor = createAction('blog/updateItemShadowColor');
export const blogUpdateItemBorder = createAction('blog/updateItemBorder');
export const blogUpdateItemBorderColor = createAction('blog/updateItemBorderColor');
export const blogUpdateItemShape = createAction('blog/updateItemShape');
